import { render, staticRenderFns } from "./CustomizeForm.vue?vue&type=template&id=a273410e&"
import script from "./CustomizeForm.vue?vue&type=script&lang=js&"
export * from "./CustomizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports